module.exports = __webpack_public_path__ + "img/BrandMe_IA_MujerNY_3.121683a3.png";